<template>
  <div class="login-page">
    <div class="signup-confirmation-block">
      <base-image :src="`${STATIC_IMG_PATH}/party-emoji.png`" />
      <h2>Congrats!</h2>
      <div>You have successfully registered. Just login to get started!</div>
      <div class="buttons-row">
        <router-link class="button button-primary" :to="{ name: 'login' }">
          Login
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { STATIC_IMG_PATH } from "Consts/static";
import BaseImage from "Public/components/BaseImage";

export default {
  name: "VerificationComplete",
  components: { BaseImage },
  data() {
    return {
      STATIC_IMG_PATH,
    };
  },
};
</script>

<style scoped></style>
